import type { DepositClabesTranslations } from "../interfaces/depositClabes";

export const depositClabesTranslations: DepositClabesTranslations = {
  // Page
  page_title: "CLABEs de depósito",
  page_subtitle: "Cuentas receptoras para depósitos SPEI (México)",
  why_banner:
    "Sin una CLABE registrada, los depósitos SPEI de la organización no se pueden atribuir ni acreditar.",
  no_org_prompt: "Selecciona una organización para ver sus CLABEs.",

  // Org selector
  org_label: "Organización",
  org_placeholder: "Buscar organización…",
  org_loading: "Cargando organizaciones…",
  org_empty: "No se encontraron organizaciones.",
  org_error: "No pudimos cargar las organizaciones.",
  org_truncated: "Hay más organizaciones de las que se muestran; refina la búsqueda por nombre.",

  // List
  list_title: "CLABEs registradas",
  filter_placeholder: "Filtrar por CLABE o nota…",
  filter_no_results: "Ninguna CLABE coincide con el filtro.",
  empty_title: "Sin CLABEs registradas",
  empty_description:
    "Registra la primera cuenta receptora para habilitar los depósitos SPEI de esta organización.",
  error_load: "No pudimos cargar las CLABEs de la organización.",
  error_retry: "Reintentar",
  registered_at: "Registrada el",
  note_label: "Nota",
  status_active: "Activa",
  status_inactive: "Inactiva",
  flavor_static: "Estática",
  flavor_dynamic: "Dinámica",
  copy_aria: "Copiar",
  copy_success: "Copiado al portapapeles",

  // Register dialog
  button_register: "Registrar CLABE",
  dialog_title: "Registrar CLABE de depósito",
  dialog_description: "La cuenta receptora quedará vinculada a la organización seleccionada.",
  dialog_org_label: "Organización",
  dialog_account_label: "CLABE",
  dialog_account_placeholder: "6461 8011 1122 2233 33",
  dialog_account_helper: "18 dígitos, sin espacios ni guiones.",
  dialog_note_label: "Nota (opcional)",
  dialog_note_placeholder: "p. ej. CLABE receptora principal",
  dialog_cancel: "Cancelar",
  dialog_submit: "Registrar",
  validation_account: "La CLABE debe tener exactamente 18 dígitos.",
  hint_already_registered: "Esta CLABE ya está registrada para esta organización.",
  toast_registered: "CLABE registrada",
  toast_already_registered: "Esta CLABE ya estaba registrada para la organización",
  error_cross_org:
    "Esta CLABE ya está asignada a otra organización. Una CLABE solo puede estar activa en una organización a la vez.",
  error_no_write_permission: "No tienes permiso para registrar CLABEs de depósito.",
  error_register: "No pudimos registrar la CLABE.",

  // Detail drawer
  drawer_title: "Detalle de la CLABE",
  drawer_section_details: "Detalles",
  drawer_section_metadata: "Metadatos",
  drawer_id: "ID",
  drawer_reference: "Referencia",
  drawer_created: "Registrada",
  drawer_updated: "Actualizada",
};
